import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconContract(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M17.367 2.553a1.885 1.885 0 0 0-2.667 0L4.426 12.827A1.436 1.436 0 0 0 4 13.854v2.702A1.44 1.44 0 0 0 5.444 18h2.702c.353 0 .74-.132 1.031-.439L19.447 7.3a1.885 1.885 0 0 0 0-2.667l-2.08-2.08Zm-3.123 3.284 1.79-1.79 1.918 1.92-1.79 1.789-1.918-1.919ZM12.83 7.252l1.918 1.918L7.91 16H6v-1.919l6.83-6.83Z"
        fill="currentColor"
      />
      <path d="M5 20a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2H5Z" fill="currentColor" />
    </BaseIcon>
  );
}
